export default {
    TABLE_TITLE: 'Grade Levels',
    GRADE_LEVEL_ADDED: 'Grade Level added',
    GRADE_LEVEL_EDITED: 'Grade Level edited',
    GRADE_LEVEL_DELETED: 'Grade Level deleted',
};
